// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingPage_container__nD9pA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #cccccc;
  text-align: center;
}

.LoadingPage_error__KcSUl {
  color: white;
  text-align: center;
  padding: 24px;
}

.LoadingPage_error__KcSUl button {
  margin-top: 16px;
  padding: 10px 20px;
  background: #8a62e6;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoadingPage/LoadingPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  color: #cccccc;\n  text-align: center;\n}\n\n.error {\n  color: white;\n  text-align: center;\n  padding: 24px;\n}\n\n.error button {\n  margin-top: 16px;\n  padding: 10px 20px;\n  background: #8a62e6;\n  color: white;\n  font-weight: bold;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoadingPage_container__nD9pA`,
	"error": `LoadingPage_error__KcSUl`
};
export default ___CSS_LOADER_EXPORT___;
